export default __webpack_public_path__ + "static/media/user-avatar.c168577e.svg";